import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-delivery-link-dialog',
  templateUrl: './delivery-link-dialog.component.html',
  styleUrls: ['./delivery-link-dialog.component.scss']
})
export class DeliveryLinkDialogComponent implements OnInit {
  public delivery: any;
  public link: string;
  public type: string;

  constructor(
    private clipboard: Clipboard,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: { delivery: any, type: string },
    private dialogRef: MatDialogRef<DeliveryLinkDialogComponent>
  ) {
    this.delivery = data.delivery;
    this.type = data.type;
  }


  ngOnInit() {
    if (this.type === 'delivered') {
      this.link = `${window.location.origin}/consegne/consegnato/${this.delivery.deliveredToken}`;
    } else if (this.type === 'paymentlink') {
      this.link = `${this.delivery.customSalePaymentLink}`;
    } else if(this.type === 'shopSale') {

      const shop = this.delivery?.platform?.toLowerCase();
      const aliasMap: Record<string, string> = {
        shopifysale: 'deluxy',
        cakesales: 'cake',
        flowerssales: 'flowers',
        businesssales: 'business',
        deluxyexperiencesales: 'deluxyexperience',
        deluxydotcomsales: 'deluxydotcom',
      };
      const platform = aliasMap[shop];
      this.link = `${window.location.origin}/sale-traking?sale_id=${this.delivery.actualOrderId}&platform=${platform}`;
    }
    else {
      this.link = `${window.location.origin}/consegne/${this.delivery.identifier}`;
    }
  }

  copyLink(input: HTMLInputElement) {
    input.select();
    this.clipboard.copy(input.value);

    this.snackBar.open('✅ Link copiato negli appunti!', '', {
      duration: 2000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: ['success-snackbar']
    });

    setTimeout(() => this.dialogRef.close(), 2000);
  }

}
